import FunctionHelper from "../../helper/FunctionHelper";

export default class Fields {
	private _fields: Array<string>;

	constructor(fields: Array<string>) {
		this._fields = FunctionHelper.applyValue(fields, []);
	}

	public contains(field: string): boolean {
		return this._fields.includes(field);
	}

	public get fields(): Array<string> {
		return this._fields;
	}

	public set fields(value: Array<string>) {
		this._fields = value;
	}
}